import { Box, Grid, IconButton } from "@mui/material";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import CloseIcon from "assets/CloseIcon";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import { isFunction } from "lodash";
import { useContext, useEffect, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import Logo from "../Logo";
import UserMenu from "../UserMenu";
import { NavbarItems } from "./NavbarConfig";
import Item from "./item";

interface Props {
  isDrawerOpen: boolean;
  toggleDrawer: any;
  setOpen: any;
  setOpenNotice: any;
}

interface MenuItem {
  label: string;
  link: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  getPaths: () => string[];
  shouldDisplay: () => boolean;
}

export default function LeftNavBar(props: Props) {
  const { isMobileScreen } = useContext(ThemeContext);
  const { isDrawerOpen, toggleDrawer } = props;
  const isImpersonated = useAppSelector((state: any) => state.app.impersonationDetails.isImpersonated);
  const store = useAppSelector((state) => state);
  const [navItems, setNavItem] = useState<MenuItem[] | null>(null);
  const loggedInUserDetails = useAppSelector((state) => state.app.loggedInUserDetails);
  const { isCorp } = loggedInUserDetails;

  useEffect(() => {
    const navItem = NavbarItems(store).filter((element: any) => element.shouldDisplay());
    setNavItem(navItem);
  }, [isImpersonated, loggedInUserDetails]);

  const navBarItems = navItems?.map((item) => (
    <Item
      key={item.label}
      label={isCorp && item.label === "My Plans" ? "Inncode Plans" : item.label}
      link={item.link}
      Icon={item.icon}
      paths={item.getPaths()}
    />
  ));

  const disclaimer = (
    <Box
      onClick={(e) => {
        toggleDrawer(false)(e);
        props.setOpen(true);
      }}
      sx={{ cursor: "pointer", textAlign: "center", marginBottom: isMobileScreen ? "24px" : "0" }}
    >
      <Typography
        variant={isMobileScreen ? "body2" : "label"}
        sx={{ fontSize: isMobileScreen ? "inherit" : "10px" }}
        color={tokens.Text.General.Color}
      >
        Franchise Disclaimer
      </Typography>
    </Box>
  );

  const PrivacyNotice = (
    <Box
      onClick={(e) => {
        toggleDrawer(false)(e);
        props.setOpenNotice(true);
      }}
      sx={{ cursor: "pointer", textAlign: "center", marginBottom: isMobileScreen ? "24px" : "0" }}
    >
      <Typography
        variant={isMobileScreen ? "body2" : "label"}
        sx={{ fontSize: isMobileScreen ? "inherit" : "10px" }}
        color={tokens.Text.General.Color}
      >
        Privacy Notice
      </Typography>
    </Box>
  );

  return (
    <Drawer
      open={isDrawerOpen}
      onClose={toggleDrawer(false)}
      variant={isMobileScreen ? "temporary" : "permanent"}
      sx={{
        ".MuiPaper-root": {
          marginTop: isImpersonated && !isMobileScreen ? "50px" : "0",
          width: isMobileScreen ? "100%" : "auto",
          maxWidth: isMobileScreen ? "100%" : "112px",
          display: "flex",
          alignItems: "center",
          justifyContent: isMobileScreen ? "flex-start" : "space-between",
          paddingTop: isMobileScreen ? "0" : "32px",
          paddingBottom: "16px",
          backgroundColor: isMobileScreen ? `${tokens.Background.General.Secondary}` : "none",
          overflowX: "hidden"
        }
      }}
    >
      {isMobileScreen ? (
        <>
          <IconButton sx={{ margin: "15px", height: "30px", alignSelf: "flex-start" }} onClick={toggleDrawer(false)}>
            <CloseIcon />
          </IconButton>
          <Grid
            container
            display="flex"
            flexDirection="column"
            height="100%"
            justifyContent="center"
            alignItems="center"
          >
            <Grid item>
              <Box sx={{ overflow: "auto", paddingX: "15px", justifySelf: "center" }}>
                <List
                  onClick={isFunction(toggleDrawer) && toggleDrawer(false)}
                  component="nav"
                  aria-label="Navbar menu options"
                >
                  {navBarItems}
                </List>
              </Box>
              <UserMenu toggleDrawer={toggleDrawer} />
            </Grid>
          </Grid>
          {disclaimer}
          {PrivacyNotice}
        </>
      ) : (
        <>
          <Logo />

          <Box sx={{ overflow: "auto", paddingX: "15px", justifySelf: "center" }}>
            <List
              onClick={isFunction(toggleDrawer) && toggleDrawer(false)}
              component="nav"
              aria-label="Navbar menu options"
            >
              {navBarItems}
            </List>
          </Box>
          <Box
            sx={{
              borderTop: `1px solid ${tokens.Border.General.Tertiary}`,
              marginX: "-16px",
              paddingX: "16px",
              paddingTop: "8px"
            }}
          >
            {disclaimer}
            {PrivacyNotice}
          </Box>
        </>
      )}
    </Drawer>
  );
}
